import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Supplier\CreateSupplierController::__invoke
* @see app/Http/Controllers/Supplier/CreateSupplierController.php
* @route '/api/supplier'
*/
const CreateSupplierController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSupplierController.url(options),
    method: 'post',
})

CreateSupplierController.definition = {
    methods: ["post"],
    url: '/api/supplier',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Supplier\CreateSupplierController::__invoke
* @see app/Http/Controllers/Supplier/CreateSupplierController.php
* @route '/api/supplier'
*/
CreateSupplierController.url = (options?: RouteQueryOptions) => {
    return CreateSupplierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Supplier\CreateSupplierController::__invoke
* @see app/Http/Controllers/Supplier/CreateSupplierController.php
* @route '/api/supplier'
*/
CreateSupplierController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateSupplierController.url(options),
    method: 'post',
})

export default CreateSupplierController